var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var FormTitleComponent = /** @class */ (function (_super) {
    __extends(FormTitleComponent, _super);
    function FormTitleComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    FormTitleComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    FormTitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-formtitle',
                    template: "\n        <label [key]=\"key\" [col]=\"{controlType: 'title', params: col.params}\" columnDir>{{ col.label }}</label>\n        <item-spanlabel *ngIf=\"col.required\" [cls]=\"'-comment -ml-1'\" [txt]=\"msg['TitleComponent.label.required']\"></item-spanlabel>\n        <item-plabel *ngIf=\"col.params?.note\" [cls]=\"'-note -mt-1'\" [txt]=\"col.params.note\"></item-plabel>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormTitleComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return FormTitleComponent;
}(ColumnBaseComponent));
export { FormTitleComponent };
//# sourceMappingURL=title.component.js.map